module.exports = __webpack_public_path__ + "assets/img/UWCSEA.b3de2ac6.jpg";